import { jsx } from 'react/jsx-runtime';
import { IconLogoBullseyeWhite } from 'nicollet-icons-react';
import { LogoLink } from './styles.js';

/**
 * Primary Target logo for use in the header. Uses standard `<a>` props.
 */

const HeaderLogo = ({
  className,
  href = '/',
  logoSize = '44px',
  ...restProps
}) => jsx(LogoLink, Object.assign({
  "aria-label": "Target home",
  className: className,
  href: href
}, restProps, {
  children: jsx(IconLogoBullseyeWhite, {
    size: logoSize
  }, void 0)
}), void 0);
HeaderLogo.displayName = 'HeaderLogo';

export { HeaderLogo };
